// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FxImageContainer, FxActionCard, FxPageContainer } from 'axp-fx-common'; // eslint-disable-line no-unused-vars
import { browserHistory } from '@americanexpress/one-app-router';
import { Badge, dlsRedBg } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars
import { userActions } from './homeInitData';
import { routes } from '../../constants/paths';
import ActionModal from '../Common/ActionContainer/ActionModal'; // eslint-disable-line no-unused-vars

const Home = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [componentPath, setComponentPath] = useState(null);

  const loginData = useSelector((state) => state.getIn([
      'modules',
      'axp-secure-file-express-root',
      'userData',
      'login',
    ])
  );

  const fxgHomeImage = useSelector((state) => state.getIn(['config', 'fxgHomeImage']));

  const { actionCnt = 0 } = loginData || {};

  const handleTertiaryButtonClick = (modalProp, path) => {
    setModalData(modalProp);
    setShowModal(true);
    setComponentPath(path);
  };

  const navigatePath = (pathname) => {
    browserHistory.push({
      pathname,
    });
  };

  return (
    <>
      <FxPageContainer>
        <div
          className="hero dls-white flex flex-align-center hidden-sm-down"
          style={{
            minHeight: '175px',
            background:
              'linear-gradient(270deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.57) 48.71%, #FFFFFF 100%)',
          }}
        >
          <div
            data-testid="img-home"
            className="hero-bg"
            style={{
              backgroundImage:
                `url(${fxgHomeImage})`,
            }}
          />
          <div className="row fluid">
            <div className="col-md-offset-1 stack pad-0">
              <h2 className="heading-6 dls-deep-blue">
                Amex File Exchange Express
              </h2>
              <h3 className="body-3 dls-gray-06">
                This is your gateway to secure file transfers.
              </h3>
            </div>
          </div>
        </div>
      </FxPageContainer>
      <FxImageContainer containerHeading="File Transfer Actions">
        <FxActionCard
          {...userActions.myActions}
          onPrimaryButtonClick={() => navigatePath(routes.myActions)}
          onTertiaryButtonClick={() => handleTertiaryButtonClick(
              userActions.myActions.modalProp,
              routes.myActions
            )}
          additionalDetail={
            actionCnt > 0 && <Badge theme={dlsRedBg}>{actionCnt}</Badge>
          }
        />
        <FxActionCard
          {...userActions.manageDigitalAssets}
          onPrimaryButtonClick={() => navigatePath(routes.manageDigitalAssets)}
          onTertiaryButtonClick={() => handleTertiaryButtonClick(
              userActions.manageDigitalAssets.modalProp,
              routes.manageDigitalAssets
            )}
        />
        <FxActionCard
          {...userActions.manageContacts}
          onPrimaryButtonClick={() => navigatePath(routes.manageContacts)}
          onTertiaryButtonClick={() => handleTertiaryButtonClick(
              userActions.manageContacts.modalProp,
              routes.manageContacts
            )}
        />
        {showModal && (
          <ActionModal
            modalProp={modalData}
            componentPath={componentPath}
            toggleModal={() => setShowModal(false)}
          />
        )}
      </FxImageContainer>
    </>
  );
};

export default Home;
